<template lang="html">
  <svg xmlns="http://www.w3.org/2000/svg" height="480" width="640" viewBox="0 0 640 480">
    <defs>
      <clipPath id="a">
        <path fill-opacity=".67" d="M-74 0h682.67v512H-74z"/>
      </clipPath>
    </defs>
    <g fill-rule="evenodd" clip-path="url(#a)" transform="translate(69.38) scale(.94)" stroke-width="1pt">
      <path fill="#e80000" d="M-74 0h768v512H-74z"/>
      <path fill="#fff" d="M-74 0h768v256H-74z"/>
      <path d="M-74 0l382.73 255.67L-74 511.01V0z" fill="#00006f"/>
    </g>
  </svg>
</template>

<script>
// http://flag-icon-css.lip.is/
export default {
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/flags/cs.vue